import { Component, OnInit } from '@angular/core';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from "@angular/common";

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    imports: [
        CommonModule,
        NgbModule
    ]
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(public _modal: NgbActiveModal) { }
  public _pageScrollY: number = 0;

  ngOnInit() {
  }

  ngAfterViewInit() {
    
  }

  ngOnDestroy() {
    
  }

  close() {
    this._modal.close();
  }
}
